import { computed } from 'vue';
import { useNavigationStore } from '~/store/navigation';

export const useIsMainMenuOpen = () => {
    const navigationStore = useNavigationStore();

    return computed(() => navigationStore.isMainMenuOpen);
};
